import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';

import { TranslatePipe } from 'app/core/i18n/translate.pipe';
import { SalesOfficeSelectDialogData } from '../../interfaces/dialog-data.interface';

@Component({
  selector: 'app-sales-office-select-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    TranslatePipe,
  ],
  templateUrl: './sales-office-select-modal.component.html',
})
export class SalesOfficeSelectModalComponent {
  search = '';
  selectedId: string | null = null;

  constructor(
    private dialogRef: MatDialogRef<SalesOfficeSelectModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SalesOfficeSelectDialogData
  ) {}

  codeOf(o: any): string {
    return o?.externalKeys?.code || o?.code || '';
  }

  // la oficina tiene almacén usable (precalculado en el padre con filterComboBox)
  selectable(o: any): boolean {
    return this.data.usableOfficeIds.includes(o._id.toString());
  }

  filteredOffices(): any[] {
    const term = (this.search || '').toLowerCase().trim();
    if (!term) return this.data.offices;
    return this.data.offices.filter(
      (o) => (o.name || '').toLowerCase().includes(term) || this.codeOf(o).toLowerCase().includes(term)
    );
  }

  isSelected(o: any): boolean {
    return this.selectedId === o._id.toString();
  }

  select(o: any): void {
    if (!this.selectable(o)) return;
    this.selectedId = o._id.toString();
  }

  confirm(): void {
    const found = this.data.offices.find((o) => o._id.toString() === this.selectedId);
    this.dialogRef.close(found);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
